import { render, staticRenderFns } from "./AuthorisePart.vue?vue&type=template&id=5bc68960&scoped=true"
import script from "./AuthorisePart.vue?vue&type=script&lang=js"
export * from "./AuthorisePart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc68960",
  null
  
)

export default component.exports